import { useRef, useContext } from "react";

import classes from "./LoginForm.module.scss";
import { LockClosedIcon } from "./Icons";
import ValidUserContext from "../authCheck";

function MfaForm() {
  const validUserContext = useContext(ValidUserContext);
  const codeInputRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();
    validUserContext.apiVerifyMfa(codeInputRef.current.value);
  };

  return (
    <div className={classes.logincontainer}>
      <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.loginInstructions}>Verify your identity</div>
        <div className={classes.loginSubtitle}>
          Enter the 6-digit code we emailed you.
        </div>

        <label className={classes.field}>
          <LockClosedIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="text"
            inputMode="numeric"
            pattern="[0-9]{6}"
            maxLength={6}
            id="mfa-code"
            name="mfa-code"
            autoComplete="one-time-code"
            placeholder="Verification code"
            ref={codeInputRef}
            required
          />
        </label>

        <button
          className={classes.loginBtn}
          disabled={validUserContext.isLoggedIn || validUserContext.isLoggingIn}
        >
          {validUserContext.isLoggingIn ? "Verifying…" : "Verify"}
        </button>

        <button
          type="button"
          className={classes.linkBtn}
          onClick={validUserContext.clearMfa}
        >
          Back to sign in
        </button>
      </form>
    </div>
  );
}

export default MfaForm;
